<template>
  <navbar-component />
  <div
    class="min-h-screen text-secondary mx-[10px] lg:mx-10 mt-5 mb-20 flex flex-col justify-start items-start gap-10 xl:mx-auto xl: max-w-6xl"
  >
    <router-view />
  </div>
  <footer-component />
</template>

<script>
import FooterComponent from '@/components/footer/Footer.vue';
import NavbarComponent from './components/Navbar/Navbar.vue';

export default {
  name: 'App',
  components: {
    FooterComponent,
    NavbarComponent,
  },
};
</script>
